import { defineCopy } from "@tami/core/intl";

import { WORKFLOW_SCRIPT_COPY_EN_US } from "./en-us/workflow-script.copy";
import { WORKFLOW_SCRIPT_COPY_ES_ES } from "./es-es/workflow-script.copy";

export const WORKFLOW_SCRIPT_COPY_PT_BR = {
  wfIntro: {
    narrative:
      "Organize seu fluxo de produção em Kanban — da ideia ao conteúdo publicado, sem perder o fio.",
  },
  wfKanban: {
    narrative:
      "Cada card mostra plataforma, formato e prazo. Arraste entre colunas para avançar o status.",
    callout:
      "Kanban da produção: arraste os cards do rascunho até o publicado.",
  },
  wfOverview: {
    narrative:
      "Veja de uma vez quantos conteúdos estão em ideia, produção, revisão ou prontos para ir ao ar.",
  },
  wfOutro: {
    narrative:
      "Rotina organizada além do calendário — listas e fluxo no mesmo lugar.",
  },
} as const;

export const WORKFLOW_SCRIPT_COPY = defineCopy(WORKFLOW_SCRIPT_COPY_PT_BR, {
  "en-US": WORKFLOW_SCRIPT_COPY_EN_US,
  "es-ES": WORKFLOW_SCRIPT_COPY_ES_ES,
});
